import { LOGOUT_REASONS } from "../../consts/auth";
import { ROUTES } from "../../consts/routes";
import { logout } from "../../helpers/auth";
import { history } from "../../history";
import { authService } from "../../services/AuthService";
import { LOCAL_STORAGE_KEYS } from "../../consts/localStorage";

export const keepSessionActive = () => {
  if (!authService.isLoggedIn()) return;

  const key = LOCAL_STORAGE_KEYS.idle_lastActive;
  const newValue = String(Date.now());
  localStorage.setItem(key, newValue);
  dispatchEvent(new StorageEvent("storage", { key, newValue }));
};

export const logoutByIdle = (withReason = true) => {
  if (authService.isLoggedIn()) {
    logout(withReason ? { reason: LOGOUT_REASONS.sessionExpire } : {});
  } else if (!window.location.pathname.includes(ROUTES.login())) {
    history.push(ROUTES.login());
  }
};
